import Footer from "../components/Footer/Footer";
import GallerySection from "../components/Sections/GallerySection";
import HeroSection from "../components/Sections/HeroSection";
import ParichayaSection from "../components/Sections/ParichayaSection";
import SamacharSection from "../components/Sections/SamacharSection";
import TathyankSection from "../components/Sections/TathyankSection";

import "./HomePage.css";

function HomePage() {
  return (
    <div className="home">
      <HeroSection />
      <ParichayaSection />
      <TathyankSection />
      <SamacharSection />
      <GallerySection />
      <Footer />
    </div>
  );
}

export default HomePage;
